import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import event from '~helpers/mixpanel';
import SvgFormat from '~helpers/svgFormat';
import { ProgressBar } from '../header';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.flex.colCross,
    justifyContent: 'center',
    padding: '132px 0',
  },
  title: {
    ...theme.typography.h2,
    margin: 0,
    textAlign: 'center',
  },
  card: {
    ...theme.flex.mainSpaceBetween,
    position: 'relative',
    width: 720,
    marginTop: 32,
    padding: '36PX 40PX 40PX',
    boxShadow: '0 0 24px 2px rgba(107, 146, 243, 0.16)',
    backgroundColor: theme.colors.gray1,
    cursor: 'pointer',
  },
  selectedCard: {
    boxShadow: '0 0 36px 2px rgba(107, 146, 243, 0.24)',
  },
  svg: {
    width: 68,
    height: 68,
    marginRight: 48,
  },
  propertyName: {
    ...theme.typography.h4,
    maxWidth: 456,
    marginTop: 8,
    marginBottom: 4,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  desc: {
    ...theme.typography.h5,
    color: theme.colors.captionColor,
    marginBottom: 10,
  },
  rightOutlined: {
    color: theme.colors.gray10,
    height: 40,
  },
  arrowOnboarding: {
    width: 12,
    height: 64,
  },
}));

const RecalledToOnboarding = ({ landlordName, processCount, onNext, propertyName }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    event('Viewed OP Return Page');
  }, []);

  const handleNextBtn = () => {
    event('Clicked OP Return Page', {
      'Clicked Position': 'CTA Btn',
      'Continue Step': processCount === 1 ? 'Step 6' : 'Step 5',
    });
    onNext();
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.title}>{t('welcome_back_user', { userName: landlordName })}</h2>
      <h2 className={classes.title}>
        {t(
          `you_are_count_${
            processCount < 2 ? 'step' : 'steps'
          }_away_from_listing_your_first_property`,
          {
            count: processCount,
          },
        )}
      </h2>
      <div
        onMouseEnter={() => {
          setHovered(true);
        }}
        onMouseLeave={() => {
          setHovered(false);
        }}
        className={classNames(classes.card, { [classes.selectedCard]: hovered })}
        onClick={handleNextBtn}
      >
        <div style={{ display: 'flex' }}>
          <SvgFormat type="back-to-onboarding" className={classes.svg} />

          <div className={classes.propertyInfo}>
            <h4 className={classes.propertyName}>{propertyName}</h4>
            <h5 className={classes.desc}>
              {t(`only_count_${processCount < 2 ? 'step' : 'steps'}_left`, { count: processCount })}
            </h5>
          </div>
        </div>

        <SvgFormat type="arrow-onboarding" className={classes.arrowOnboarding} />

        <ProgressBar count={Number(6 - processCount)} />
      </div>
    </div>
  );
};

RecalledToOnboarding.propTypes = {
  landlordName: PropTypes.string,
  processCount: PropTypes.number,
  onNext: PropTypes.func,
  propertyName: PropTypes.string,
};

export default RecalledToOnboarding;
